export const chartTypeConfig = [
    {
        chartType: 'Bars(Thin)',
        className:'bar',
        imagePath: '/images/chartType/bar.svg',
        image2Path: '/images/chartType/bar2.svg',
        toolTip: 'Bar Chart'
    },
    {
        chartType: 'Bars(Thick)',
        className:'bar',
        imagePath: '/images/chartType/bar.svg',
        image2Path: '/images/chartType/bar2.svg',
        toolTip: 'Bar Chart'
    },
    {
        chartType: 'LineChart',
        className:'line',
        imagePath: '/images/chartType/line.svg',
        image2Path: '/images/chartType/line2.svg',
        toolTip: 'Line Chart'
    },
    {
        chartType: 'Candles',
        className:'candlestick',
        imagePath: '/images/chartType/candlestick.svg',
        image2Path: '/images/chartType/candlestick2.svg',
        toolTip: 'Candlestick Chart'
    },
    {
        chartType: 'Kagi',
        className:'kagi',
        imagePath: '/images/chartType/kagi.svg',
        image2Path: '/images/chartType/kagi2.svg',
        toolTip: 'Kagi Chart'
    },
    {
        chartType: 'HeikenAshi',
        className:'heikenAshi',
        imagePath: '/images/chartType/heikenAshi.svg',
        image2Path: '/images/chartType/heikenAshi2.svg',
        toolTip: 'Heikin Ashi Chart'
    },
    {
        chartType: 'UpAndDown',
        className:'updown',
        imagePath: '/images/chartType/updown.svg',
        image2Path: '/images/chartType/updown2.svg',
        toolTip: 'Up/Down Chart'
    },
    {
        chartType: 'PnF',
        className:'figure',
        imagePath: '/images/chartType/point-figure.svg',
        image2Path: '/images/chartType/point-figure2.svg',
        toolTip: 'Point & Figures Chart'
    },
    {
        chartType: 'BarTrend',
        className:'trend',
        imagePath: '/images/chartType/trend.svg',
        image2Path: '/images/chartType/trend2.svg',
        toolTip: 'Bar Trend Chart'
    },

]